import { render, staticRenderFns } from "./DynamicFormatIcon.vue?vue&type=template&id=2ccfdf81&scoped=true"
import script from "./DynamicFormatIcon.vue?vue&type=script&lang=js"
export * from "./DynamicFormatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfdf81",
  null
  
)

export default component.exports